"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableDialog = void 0;
const Utilities_1 = require("../../../javascript/Utilities");
const ExternalInput_1 = require("./ExternalInput");
const Instance_1 = require("../../../model/Instance");
/**
* Types of arithmetic operations the variable allows
*/
var VariableArithType;
(function (VariableArithType) {
    VariableArithType[VariableArithType["None"] = 0] = "None";
    VariableArithType[VariableArithType["Day"] = 1] = "Day";
    VariableArithType[VariableArithType["HourMinuteSecond"] = 2] = "HourMinuteSecond";
    VariableArithType[VariableArithType["DayHourMinuteSecond"] = 3] = "DayHourMinuteSecond";
    VariableArithType[VariableArithType["Week"] = 4] = "Week";
    VariableArithType[VariableArithType["Month"] = 5] = "Month";
    VariableArithType[VariableArithType["Quarter"] = 6] = "Quarter";
    VariableArithType[VariableArithType["Year"] = 7] = "Year"; // Add/subtract year(s)
})(VariableArithType || (VariableArithType = {}));
/**
* Variablen-Dialog
*/
class VariableDialog extends ExternalInput_1.ExternalInput {
    constructor(controlColl, m_expression, m_allowedVariables) {
        super(controlColl, new Instance_1.Instance(), undefined);
        this.m_expression = m_expression;
        this.m_allowedVariables = m_allowedVariables;
        this.arithType = VariableArithType.None;
        this.windowContentCssClass = "eiVariableDialog";
        this.windowWidth = 650;
        this.windowHeight = 150;
    }
    destroyWidgets() {
    }
    getUpdatedInstance() {
        return Promise.resolve(this.currentInstance);
    }
    updateOperatorButtonState(state) {
        let that = this;
        let opButton = $("#" + that.idData.operatorButton);
        switch (state) {
            case 0:
                opButton.html("...").removeClass("btn-primary");
                break;
            case 1:
                opButton.html("+").addClass("btn-primary");
                break;
            case 2:
                opButton.html("-").addClass("btn-primary");
                break;
        }
        opButton.attr("data-state", state.toString());
        that.updatePickersEnabled();
    }
    initWindowContents() {
        let that = this;
        let idData = {
            synUtil: Utilities_1.synUtil,
            readOnly: that.input.readonlyForExtInput
        };
        $.each([
            "variableCombo",
            "operatorButton",
            "yearPicker",
            "quarterPicker",
            "monthPicker",
            "weekPicker",
            "dayPicker",
            "hourPicker",
            "minutePicker",
            "secondPicker"
        ], function (idx, id) {
            idData[id] = id + "_" + that.windowData.guid;
        });
        that.idData = idData;
        let varDialogMarkup = require("../../../templates/externalInputs/VariableDialog.tmpl.html");
        let template = kendo.template(varDialogMarkup);
        let result = template(idData);
        that.widgetContainer.html(result);
        that.widgetContainer.find(".variableNumericPicker").kendoNumericTextBox({ format: "n0" });
        let opButton = $("#" + that.idData.operatorButton);
        opButton.on("click", function () {
            let state = parseInt(opButton.attr("data-state"), 10);
            state = ++state % 3;
            that.updateOperatorButtonState(state);
        });
        $("#" + that.idData.variableCombo).kendoDropDownList({
            dataTextField: "label",
            dataValueField: "name",
            dataSource: that.m_allowedVariables,
            change() {
                that.updateVisiblePickers();
            }
        });
        that.parseExpression();
        let variableCombo = $("#" + that.idData.variableCombo).data("kendoDropDownList");
        variableCombo.select(0);
        that.updateVisiblePickers();
        that.updatePickersEnabled();
        return Promise.resolve();
    }
    setAdditionalData() {
        let that = this;
        let variableCombo = $("#" + that.idData.variableCombo).data("kendoDropDownList");
        let selected = variableCombo.dataItem(variableCombo.select());
        let variable = "#" + selected.name + "#";
        that.additionalData = {
            valueEscaped: variable,
            valueUnescaped: variable
        };
        let state = $("#" + that.idData.operatorButton).attr("data-state");
        if (state !== "0") {
            // Build arithmetic subtree
            let year = 0, quarter = 0, month = 0, week = 0, day = 0, hour = 0, minute = 0, second = 0;
            let convertDate = function (days) {
                day = days;
                // days => months
                month = Math.floor(day / 30);
                day %= 30;
                // months => years
                year = Math.floor(month / 12);
                month %= 12;
            };
            that.widgetContainer.find(".variableNumericPicker.k-widget:visible")
                .each(function (idx, elem) {
                let $elem = $(elem);
                let input = $elem.find("input").last();
                let picker = input.data("kendoNumericTextBox");
                let val = picker.value();
                let tmp = val;
                switch (input.attr("data-component")) {
                    case "year":
                        year = val;
                        break;
                    case "quarter":
                        convertDate(val * 90);
                        break;
                    case "month":
                        convertDate(val * 30);
                        break;
                    case "week":
                        convertDate(val * 7);
                        break;
                    case "day":
                        convertDate(val);
                        break;
                    case "hour":
                        hour = val;
                        break;
                    case "minute":
                        minute = val;
                        break;
                    case "second":
                        second = val;
                        break;
                    default:
                        break;
                }
            });
            let dt = kendo.format(VariableDialog.DateArithFormat, day, month, year, hour, minute, second);
            if (dt !== VariableDialog.DateArithZero) {
                let tmp = that.additionalData;
                that.additionalData = {
                    childOperator: {
                        lExpression: tmp,
                        operatorType: (state === "1" ? "Plus" : "Minus"),
                        rExpression: {
                            valueEscaped: dt,
                            valueUnescaped: dt
                        }
                    }
                };
            }
        }
    }
    parseExpression() {
        let that = this;
        let variable;
        let operator;
        let arithValue;
        let exp = that.m_expression;
        if (exp.childOperator && exp.childOperator.operatorType === "Quotes")
            exp = exp.childOperator.rExpression;
        if (exp.valueEscaped) {
            // no date arith
            variable = exp.valueEscaped;
        }
        else if (exp.childOperator) {
            // date arith
            variable = exp.childOperator.lExpression.valueEscaped;
            operator = exp.childOperator.operatorType;
            arithValue = exp.childOperator.rExpression.valueEscaped;
        }
        // otherwise, the expression is empty
        let ddl = $("#" + that.idData.variableCombo).data("kendoDropDownList");
        if (variable)
            ddl.select(function (dataItem) {
                return "#" + dataItem.name + "#" === variable;
            });
        if (operator)
            that.updateOperatorButtonState(operator === "Plus" ? 1 : 2);
        if (arithValue) {
            let week = 0, quarter = 0;
            let cursor = arithValue.length - 2;
            let second = parseInt(arithValue.substring(cursor, cursor + 2), 10);
            cursor -= 3;
            let minute = parseInt(arithValue.substring(cursor, cursor + 2), 10);
            cursor -= 3;
            let hour = parseInt(arithValue.substring(cursor, cursor + 2), 10);
            cursor -= 5;
            let year = parseInt(arithValue.substring(cursor, cursor + 4), 10);
            cursor -= 3;
            let month = parseInt(arithValue.substring(cursor, cursor + 2), 10);
            cursor -= 3;
            let day = parseInt(arithValue.substring(cursor, cursor + 2), 10);
            let variable = ddl.dataItem(ddl.select());
            if (variable) {
                switch (variable.name) {
                    // variable.currentdate(time) => get total days from years, months, days
                    case "variable.currentdate":
                    case "variable.currentdatetime":
                    case "variable.currentweek":
                        month += year * 12;
                        year = 0;
                        day += month * 30;
                        month = 0;
                        // variable.currentweek => get total weeks total days
                        if (variable.name === "variable.currentweek") {
                            week = day / 7;
                            day = 0;
                        }
                        break;
                    // variable.currentmonth => get total months from years, months
                    case "variable.currentmonth":
                    case "variable.currentquarter":
                        month += year * 12;
                        year = 0;
                        if (variable.name === "variable.currentquarter") {
                            quarter = month / 3;
                            month = 0;
                        }
                        break;
                    case "variable.currentyear":
                    case "variable.currentbusinessyear":
                    case "variable.firstdayofcurrentbusinessyear": // auch hier werden Jahre addiert/subtrahiert!
                    case "variable.lastdayofcurrentbusinessyear": // auch hier werden Jahre addiert/subtrahiert!
                    default:
                        break;
                }
            }
            that.widgetContainer.find("input.secondPicker").last().data("kendoNumericTextBox").value(second);
            that.widgetContainer.find("input.minutePicker").last().data("kendoNumericTextBox").value(minute);
            that.widgetContainer.find("input.hourPicker").last().data("kendoNumericTextBox").value(hour);
            that.widgetContainer.find("input.dayPicker").last().data("kendoNumericTextBox").value(day);
            that.widgetContainer.find("input.monthPicker").last().data("kendoNumericTextBox").value(month);
            that.widgetContainer.find("input.yearPicker").last().data("kendoNumericTextBox").value(year);
            that.widgetContainer.find("input.weekPicker").last().data("kendoNumericTextBox").value(week);
            that.widgetContainer.find("input.quarterPicker").last().data("kendoNumericTextBox").value(quarter);
        }
    }
    updatePickersEnabled() {
        let that = this;
        let state = $("#" + that.idData.operatorButton).attr("data-state");
        that.widgetContainer.find(".variableNumericPicker")
            .each(function (idx, elem) {
            let tb = $(this).data("kendoNumericTextBox");
            if (tb)
                tb.enable(state !== "0");
        });
    }
    updateVisiblePickers() {
        let that = this;
        let variableCombo = $("#" + that.idData.variableCombo).data("kendoDropDownList");
        let selected = variableCombo.dataItem(variableCombo.select());
        switch (selected.name) {
            case "variable.currentyear":
            case "variable.currentbusinessyear":
            case "variable.firstdayofcurrentbusinessyear":
            case "variable.lastdayofcurrentbusinessyear":
                that.arithType = VariableArithType.Year;
                break;
            case "variable.currentquarter":
                that.arithType = VariableArithType.Quarter;
                break;
            case "variable.currentmonth":
                that.arithType = VariableArithType.Month;
                break;
            case "variable.currentweek":
                that.arithType = VariableArithType.Week;
                break;
            default:
                let fieldType = that.controlColl.Input.field.fieldType;
                if (fieldType === "Date")
                    that.arithType = VariableArithType.Day;
                else if (fieldType === "Time")
                    that.arithType = VariableArithType.HourMinuteSecond;
                else if (fieldType === "DateTime")
                    that.arithType = VariableArithType.DayHourMinuteSecond;
                else
                    that.arithType = VariableArithType.None;
                break;
        }
        that.showVisiblePickers();
    }
    showVisiblePickers() {
        let that = this;
        that.widgetContainer.find(".variableNumericPicker").closest(".k-widget").css("display", "none");
        that.widgetContainer.find("label.varLabel").not(".comboLabel").css("display", "none");
        $("#" + that.idData.operatorButton).css("display", "");
        switch (that.arithType) {
            case VariableArithType.Day:
                that.widgetContainer.find(".dayPicker").closest(".k-widget").css("display", "");
                break;
            case VariableArithType.DayHourMinuteSecond:
                that.widgetContainer.find(".dayPicker").closest(".k-widget").css("display", "");
                that.widgetContainer.find(".hourPicker").closest(".k-widget").css("display", "");
                that.widgetContainer.find(".minutePicker").closest(".k-widget").css("display", "");
                that.widgetContainer.find(".secondPicker").closest(".k-widget").css("display", "");
                break;
            case VariableArithType.HourMinuteSecond:
                that.widgetContainer.find(".hourPicker").closest(".k-widget").css("display", "");
                that.widgetContainer.find(".minutePicker").closest(".k-widget").css("display", "");
                that.widgetContainer.find(".secondPicker").closest(".k-widget").css("display", "");
                break;
            case VariableArithType.Month:
                that.widgetContainer.find(".monthPicker").closest(".k-widget").css("display", "");
                break;
            case VariableArithType.Quarter:
                that.widgetContainer.find(".quarterPicker").closest(".k-widget").css("display", "");
                break;
            case VariableArithType.Week:
                that.widgetContainer.find(".weekPicker").closest(".k-widget").css("display", "");
                break;
            case VariableArithType.Year:
                that.widgetContainer.find(".yearPicker").closest(".k-widget").css("display", "");
                break;
            default:
                $("#" + that.idData.operatorButton).css("display", "none");
                break;
        }
        that.widgetContainer.find(".variableNumericPicker.k-widget:visible")
            .each(function (idx, elem) {
            let id = $(elem).find("input").last().attr("id");
            that.widgetContainer.find("label.varLabel[for='" + id + "']").css("display", "");
        });
    }
}
exports.VariableDialog = VariableDialog;
// dd-MM-yyyy HH:mm:ss
VariableDialog.DateArithFormat = "{0:00}-{1:00}-{2:0000} {3:00}:{4:00}:{5:00}";
// Timespan of zero
VariableDialog.DateArithZero = "00-00-0000 00:00:00";
